import { DictionaryBrand, DictionaryBrandSchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { ItemMapping } from "core/src/slices/etlData/slice/etlData.types";

export type PatchBrandMappingRequest = {
	brandsMapping: ItemMapping;
};

export type PatchBrandMappingResponse = {
	dictionaryBrands: DictionaryBrand[];
};

export const patchBrandMapping = createAppAsyncThunk<PatchBrandMappingResponse, PatchBrandMappingRequest>(
	"patchBrandMapping",
	async ({ brandsMapping }, { extra, getState, rejectWithValue }) => {

		const { extractBrands, dictionaryBrands } = getState().etlData;

		const tmpDictionaryBrands = [...dictionaryBrands];

		const extractBrand = extractBrands.find((extractBrand) => extractBrand.id === brandsMapping.extractId);
		const dictionnaryBrand = dictionaryBrands.find((dictionaryBrand) => dictionaryBrand.id === brandsMapping.dicoId);

		if (
			dictionnaryBrand?.hb_brand_id === extractBrand?.hb_id
			&& dictionnaryBrand?.hb_brand_libelle === extractBrand?.libelle
		) {
			return rejectWithValue("No changes");
		}

		if (extractBrand) {
			const dictionaryBrandsUpdated = await extra.etlClient.update(
				DictionaryBrandSchema,
				brandsMapping.dicoId,
				{
					hb_brand_id: extractBrand?.hb_id,
					hb_brand_libelle: extractBrand?.libelle
				},
			);

			if (dictionaryBrandsUpdated) {
				tmpDictionaryBrands.splice(
					tmpDictionaryBrands.findIndex((brand) => brand.id === brandsMapping.dicoId),
					1,
					dictionaryBrandsUpdated.data
				);
			}

		}

		return {
			dictionaryBrands: tmpDictionaryBrands
		}
	}
);
